import Cookies from 'js-cookie';
export var setCookie = function (name, value, options) {
    if (options === void 0) { options = {}; }
    Cookies.set(name, value, options);
};
export var getCookie = function (name) { return Cookies.get(name); };
export var removeCookie = function (name) {
    Cookies.remove(name);
};
